<template>
    <div class="input radios">
        <fieldset>
            <legend>{{ label }}</legend>
            <label class="btn btn-default radioLabel" :class="{ 'buttonColorChange': model === option.value }"
                v-for="option in options" :key="option.value">
                <input type="radio" :value="option.value" :name="name" v-model="model">
                <span class="spanRadioButtons">{{ option.label }}</span>
            </label>
        </fieldset>
    </div>
</template>
<script setup lang="ts">
import type { Option } from '../../types/GenericTypes';
const model = defineModel<string>();

defineProps({
    name: {
        type: String,
        required: true,
    },
    options: {
        type: Array<Option>,
        required: true,
    },
    label: {
        type: String,
        required: false,
    },
});
</script>
